import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDataList(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/customers/paginate', payload.body,
            { params: payload.queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    storeMeter(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/customers', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateMeter(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`/customers/${payload.id}`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadImage(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/customers/upload-image', payload)
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    }
  },
}
